import "@/design/index.scss";
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import store from '@/state/store'
import vco from "v-click-outside"
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2';
import badgeClassGetter from "@/mixins/badgeClassGetter";
import httpClient from "@/mixins/httpClient";
import formatDate from '@/filters/formatDate';
import formatCurrency from '@/filters/formatCurrency';
import formatNumberWithCommas from '@/filters/formatNumberWithCommas';

const VueScrollTo = require('vue-scrollto')

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(BootstrapVue)
Vue.use(Scrollspy);
Vue.use(vco)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
  },
  installComponents: true
})
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueRouter)
Vue.use(VueScrollTo)
Vue.use(VueSweetalert2);
Vue.mixin(badgeClassGetter)
Vue.mixin(httpClient)
Vue.filter('formatDate', formatDate)
Vue.filter('formatCurrency', formatCurrency)
Vue.filter('formatNumberWithCommas', formatNumberWithCommas)

Vue.config.productionTip = false

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
